import config from '../config';

const appConfig = config();
const apiTicket = appConfig.apiPrefix;
const { v1, v2 } = appConfig.apiVersion;

const network = (client) => ({
  getTicketStates: () => client.get(`${apiTicket}${v1}/ticket/states`),

  getTicketGroupStates: () =>
    client.get(`${apiTicket}${v1}/ticket-groups/states`),

  getDependants: ({ params: { id } }) =>
    client.get(`${apiTicket}${v1}/ticket/${id}/dependants`),
  // Company registration is handled by RegistrationTicketService (v2).
  // --> Obtener informacion de un ticket de transferencia
  getTransferInformation: (payload) =>
    client.get(`${apiTicket}${v2}/tickets/${payload}/transfer-policies`),
  // --> Obtener los grupos de un ticket de transferencia
  getTransferGroups: (payload) =>
    client.get(`${apiTicket}${v2}/tickets/${payload}/transfer-groups`),
  // --> Crear un ticket de alta individual a colaborador
  createIndividualIncorporationTicketToCollaborator: (payload) =>
    client.post(`${apiTicket}${v1}/ticket/alta`, payload),
  // --> Obtener el texto de consentimiento de un ticket de alta creado
  getConsentText: (payload, token) =>
    client.get(`${apiTicket}${v1}/ticket/get-consent-text/${payload}`, {
      ...(token ? { headers: { Authorization: `Bearer ${token}` } } : {})
    }),
  // TODO: Ver donde se usa este
  patchConsentText: (payload, token) =>
    client.patch(
      `${apiTicket}${v1}/ticket/employee-consent/${payload}`,
      undefined,
      { ...(token ? { headers: { Authorization: `Bearer ${token}` } } : {}) }
    ),
  // TODO: Ver donde se usa este
  cancelTicket: (payload) =>
    client.post(`${apiTicket}${v1}/ticket/cancelTicket/${payload}`),
  // --> Finalizar ticket de baja
  finishTicketBaja: (payload) =>
    client.patch(`${apiTicket}${v1}/ticket/baja/${payload}/finish`),
  // -->
  commentId: (payload) =>
    client.get(`${apiTicket}${v1}/ticket/${payload}/comments`),
  // --> Obtener si este ticket depende de la renta de el empleado
  ticketIncome: (payload, token) =>
    client.get(`${apiTicket}${v1}/ticket/${payload}/income`, {
      ...(token ? { headers: { Authorization: `Bearer ${token}` } } : {})
    }),

  getCompanyList: () =>
    client.get(`${apiTicket}${v1}/form/registration/individual/companies`), // Obtener lista de companias
  getGroupCompanyList: (payload) =>
    client.get(
      `${apiTicket}${v1}/form/registration/individual/groups${payload}`
    ), // Obtener lista de companias
  getinsuranceCompanyList: (id_company, id_group) =>
    client.get(
      `${apiTicket}${v1}/form/registration/individual/insurance-companies`,
      {
        params: {
          company: id_company,
          groups: id_group
        }
      }
    ), // Obtener lista de las aseguradoras
  getinsuranceCompanyPolicyList: (rut, id_company, id_insurance, id_group) =>
    client.get(`${apiTicket}${v1}/form/registration/individual/policies`, {
      params: {
        rut,
        company: id_company,
        insurancecompany: id_insurance,
        groups: id_group
      }
    }), // Obtener lista de las polizas
  getinsuranceCompanyDocumentsList: (payload) =>
    client.get(
      `${apiTicket}${v1}/form/registration/individual/insurance-files?insurancecompany=${payload}`
    ), // Obtener lista de las documentos
  getEmployeeDataByRut: (payload) =>
    client.get(`${apiTicket}${v1}/employee/rut/${payload}`), // Obtener informacion de un empleado por rut

  // api Ticket

  customIdentity: (payload, token) =>
    client.get(`${apiTicket}${v1}/fileTicket/customer-identity/${payload}`, {
      ...(token ? { headers: { Authorization: `Bearer ${token}` } } : {})
    }),
  fileTicketHistory: (payload) =>
    client.get(`${apiTicket}${v1}/fileTicket/${payload}/history`),
  createCustomerIdentity: (payload, token) =>
    client.post(`${apiTicket}${v1}/fileTicket/customer-identity/`, payload, {
      ...(token ? { headers: { Authorization: `Bearer ${token}` } } : {})
    }),

  resendEmail: (ticketId, email) => {
    if (email) {
      return client.post(
        `${apiTicket}${v1}/ticket/${ticketId}/resend-form-incorporation`,
        email
      );
    }
    return client.post(
      `${apiTicket}${v1}/ticket/${ticketId}/resend-form-incorporation`
    );
  },
  commentTicketId: (payload) =>
    client.get(`${apiTicket}${v1}/comment/by_ticket_id/${payload}`),

  masiveCommentsById: (payload) =>
    client.get(`${apiTicket}${v1}/ticket-groups/${payload}/comments/`),
  createCommentMasiveTicket: (payload) =>
    client.post(`${apiTicket}${v1}/ticket-groups/comments/`, payload),

  dataTicket: (payload, token) =>
    client(`${apiTicket}${v1}/ticket/${payload}/verify/${token}`),
  apiTicket: () => client.get(`${apiTicket}${v1}`),
  getTicketId: (payload, token) =>
    client.get(`${apiTicket}${v1}/ticket/${payload}`, {
      ...(token ? { headers: { Authorization: `Bearer ${token}` } } : {})
    }),
  updateTicket: (id, payload) =>
    client.patch(`${apiTicket}${v2}/tickets/${id}`, payload),
  employeTicket: (payload) =>
    client.get(`${apiTicket}${v1}/employee-ticket/by_ticket_id/${payload}`),
  sendInformationToInsuranceCompany: (id, selectedCoverageGroupCompanyIds) =>
    client.patch(`${apiTicket}${v2}/tickets/${id}/status`, {
      status: 8,
      ...(selectedCoverageGroupCompanyIds !== undefined
        ? { selectedCoverageGroupCompanyIds }
        : {})
    }),

  insuranceCompanyUploadFormType: (payload) =>
    client.post(`${apiTicket}${v1}/filesInsuranceCompany`, payload),
  updateInsuranceCompanyUploadFormType: (payload, id) =>
    client.put(`${apiTicket}${v1}/filesInsuranceCompany/${id}`, payload),
  deleteInsuranceCompanyUploadFormType: (payload) =>
    client.delete(`${apiTicket}${v1}/filesInsuranceCompany/${payload}`),

  // Busqueda de stock
  employeeStockSearch: (type, payload) => {
    const searchPath = type === 'search_cases' ? 'search-cases' : type;
    return client.get(`${apiTicket}${v2}/stock/${searchPath}?${payload}`);
  },

  caseTicketId: (payload) =>
    client.get(`${apiTicket}${v1}/case/ticket/${payload}`),
  caseAntecedentes: (payload) =>
    client.post(`${apiTicket}${v1}/case/antecedentes/`, payload),

  caseAntecedentesVerify: (id, token) =>
    client.get(`${apiTicket}${v1}/case/verify/${id}/${token}`),

  caseId: (payload) => client.get(`${apiTicket}${v1}/case/id/${payload}`),
  typeCases: () => client.get(`${apiTicket}${v1}/case/typecases`),
  fileByCase: (payload) =>
    client.get(`${apiTicket}${v1}/fileTicket/get_files_by_case/${payload}`),
  fileTicketRecord: (payload) =>
    client.get(`${apiTicket}${v1}/fileTicket/fileRecords/${payload}/ticket`),
  caseState: (payload) => client.get(`${apiTicket}${v1}/case/state/${payload}`),
  getFile: (payload) =>
    client.get(`${apiTicket}${v1}/fileTicket/getFile/${payload}`),
  fileInsuranceCompany: (payload) =>
    client.get(`${apiTicket}${v1}/filesInsuranceCompany/${payload}`),
  typeFormsInsuranceCompany: (payload) =>
    client.get(`${apiTicket}${v1}/insuranceCompany/${payload}/files`),
  filesByTicket: (payload) =>
    client.get(`${apiTicket}${v1}/ticket/${payload}/alta-file-upload`),
  reapplyFile: (id, payload) =>
    client.put(`${apiTicket}${v1}/fileTicket/reject/${id}`, payload),
  getInsuranceDocuments: (payload, token) =>
    client.get(`${apiTicket}${v1}/filesInsuranceCompany/ticket/${payload}`, {
      ...(token ? { headers: { Authorization: `Bearer ${token}` } } : {})
    }),
  postFileInsuranceCompany: (id, payload, token) =>
    client.post(
      `${apiTicket}${v1}/filesInsuranceCompany/ticket/${id}`,
      payload,
      { ...(token ? { headers: { Authorization: `Bearer ${token}` } } : {}) }
    ),

  TicketTableQuery: (params, signal) =>
    client.get(`${apiTicket}${v1}/ticket?${params}`, { signal }),
  TicketTableQueryCases: (params, signal) =>
    client.get(`${apiTicket}${v1}/case?${params}`, { signal }),
  TicketTableQueryGroups: (params) =>
    client.get(`${apiTicket}${v1}/ticket-groups?${params}`),

  TicketResendFormIncorporation: (id, payload) =>
    client.post(
      `${apiTicket}${v1}/ticket/${id}/resend-form-incorporation`,
      payload
    ),

  TicketqueryParamsAlta: () => client.get(`${apiTicket}${v1}/ticket?type=Alta`), // arreglar despues el parametro como {Alta}
  TicketqueryParamsBaja: () => client.get(`${apiTicket}${v1}/ticket?type=Baja`), // arreglar despues el parametro como {Baja}
  TicketqueryParamsModificacion: () =>
    client.get(`${apiTicket}${v1}/ticket?type=Modificacion`), // arreglar despues el parametro como {Modificacion}

  postTicketBajaIndividual: (payload) =>
    client.post(`${apiTicket}${v1}/ticket/baja`, payload),
  ticketModificacionMasiva: (payload) =>
    client.post(`${apiTicket}${v1}/ticket-groups/modificacion`, payload),
  getFileUrl: () =>
    `${appConfig.baseURL}${apiTicket}${v1}/fileTicket/getFile/a8082d108a28c9ff60feb44308abc7f5`,

  dashboardGraphicCompanyType: (payload = '') =>
    client.get(`${apiTicket}${v1}/dashboard/graphic${payload}`),
  dataMovmentCompany: () =>
    client.get(`${apiTicket}${v1}/dashboard/graphic?company=1&type=1`),
  companyTickets: (payload) =>
    client.get(`${apiTicket}${v1}/company/${payload}/tickets`), // verificar y cambiar 1 por payload

  createComment: (payload) =>
    client.post(`${apiTicket}${v1}/comment/`, payload),
  cancelTicketAlta: (payload) =>
    client.post(`${apiTicket}${v1}/ticket/alta/${payload}/cancel`),
  cancelTicketBaja: (payload) =>
    client.post(`${apiTicket}${v1}/ticket/baja/${payload}/cancel`),
  cancelTicketModificacionIndividual: (payload) =>
    client.post(`${apiTicket}${v1}/ticket/modification/${payload}/cancel`),
  cancelTicketModificacionMasiva: (payload) =>
    client.post(
      `${apiTicket}${v1}/ticket-groups/modificacion/${payload}/cancel`
    ),
  ejecutarTicketModificacion: (payload) =>
    client.post(`${apiTicket}${v1}/ticket/modification/${payload}/finish`),
  ejecutarTicketMOficacionMasiva: (payload) =>
    client.post(
      `${apiTicket}${v1}/ticket-groups/modificacion/${payload}/success`
    ),
  // Validar token para la resolicitud de documento
  verifyDocumentRequestToken: (id, token) =>
    client.get(`${apiTicket}${v1}/fileTicket/verify/${id}/${token}`),
  uploadDocumentRequested: (payload, token) =>
    client.post(`${apiTicket}${v1}/fileTicket/reuploadFile`, payload, {
      ...(token ? { headers: { Authorization: `Bearer ${token}` } } : {})
    }),
  getOldDocument: (payload, token) =>
    client.get(`${apiTicket}${v1}/fileTicket/${payload}`, {
      ...(token ? { headers: { Authorization: `Bearer ${token}` } } : {})
    }),
  getBlankDocument: (payload, token) =>
    client.get(`${apiTicket}${v1}/filesInsuranceCompany/${payload}/getFile`, {
      ...(token ? { headers: { Authorization: `Bearer ${token}` } } : {})
    }),

  // TODO: VER BIEN EL ENDPOINT CREATESTATE SI SE ESTA OCUPANDO EN ALGUN LADO
  createStateTicket: (payload) =>
    client.post(`${apiTicket}${v1}/state_ticket/create_state_ticket/`, payload),
  finishAltaIndividual: (payload) =>
    client.post(`${apiTicket}${v1}/ticket/alta/${payload}/finish`),
  createCaseId: (payload, token) =>
    client.post(`${apiTicket}${v1}/case/${payload}/verify/${token}`),
  createStateCase: (id, payload) =>
    client.post(`${apiTicket}${v1}/case/${id}/add-state`, payload),
  securedFileUpload: (payload) =>
    client.post(`${apiTicket}${v1}/fileTicket/asegurado/uploadFile/`, payload),

  caseFilesUpload: (id, payload, token) =>
    client.post(
      `${apiTicket}${v1}/case/antecedentes/${id}/upload-file-employee`,
      payload,
      { ...(token ? { headers: { Authorization: `Bearer ${token}` } } : {}) }
    ),

  uploadFile: (payload) =>
    client.post(`${apiTicket}${v1}/fileTicket/uploadFile/`, payload),
  ticketOptionalFiles: (ticketId) =>
    client.get(`${apiTicket}${v1}/ticket/${ticketId}/optional-files`),
  uploadFileMultiple: (payload) =>
    client.post(`${apiTicket}${v1}/fileTicket/uploadMultipleFile`, payload),
  postTicketModification: (payload) =>
    client.post(`${apiTicket}${v1}/ticket/modification`, payload),
  saveConsentDate: (id, token) =>
    client.patch(`${apiTicket}${v1}/ticket/employee-consent/${id}`, undefined, {
      ...(token ? { headers: { Authorization: `Bearer ${token}` } } : {})
    }),
  updateInsuredState: (id, payload, token) =>
    client.post(`${apiTicket}${v1}/ticket/${id}/add-state`, payload, {
      ...(token ? { headers: { Authorization: `Bearer ${token}` } } : {})
    }),
  createTransferTicket: (payload) =>
    client.post(`${apiTicket}${v2}/tickets/transfer`, payload),
  createEmployeeDependentsIncorporation: (payload) =>
    client.post(
      `${apiTicket}${v2}/tickets/collaborator-dependents-incorporation`,
      payload
    ),
  createDependentsExclusion: (payload) =>
    client.post(`${apiTicket}${v1}/ticket/dependents-exclusions`, payload),
  createInsuranceDependentsIncorporation: (payload) =>
    client.post(
      `${apiTicket}${v2}/tickets/insurance-dependents-incorporations`,
      payload
    ),
  getInsuranceCompaniesByEmployeeRut: ({ rut, companies, groupCompany }) =>
    client.get(
      `${apiTicket}${v2}/form/transfer/individual/insurance-companies`,
      { params: { rut, companies, groupCompany } }
    ),
  executeTransferTicket: (id, payload = {}) =>
    client.patch(`${apiTicket}${v2}/tickets/${id}/status`, {
      ...payload,
      status: 3
    }),
  cancelTransferTicket: (id, payload = {}) =>
    client.patch(`${apiTicket}${v2}/tickets/${id}/status`, {
      ...payload,
      status: 4
    }),
  cancelDependentsIncorporation: (id) =>
    client.post(
      `${apiTicket}${v1}/ticket/dependents-incorporations/${id}/cancel`
    ),
  finishDependentsIncorporation: (id) =>
    client.post(
      `${apiTicket}${v1}/ticket/dependents-incorporations/${id}/finish`
    ),
  cancelDependentsExclusion: (id) =>
    client.post(`${apiTicket}${v1}/ticket/dependents-exclusions/${id}/cancel`),
  finishDependentsExclusion: (id) =>
    client.post(`${apiTicket}${v1}/ticket/dependents-exclusions/${id}/finish`),
  sendToInsuranceDependentsIncorporation: (id) =>
    client.post(
      `${apiTicket}${v1}/ticket/dependents-incorporations/${id}/send-to-insurance`
    ),
  getTicketV2: (ticketId, token) =>
    client.get(`${apiTicket}${v2}/tickets/${ticketId}`, {
      ...(token ? { headers: { Authorization: `Bearer ${token}` } } : {})
    }),
  getTicketAvailableCoverages: (ticketId, token) =>
    client.get(
      `${apiTicket}${v2}/tickets/${ticketId}/dependants-available-coverages`,
      {
        ...(token ? { headers: { Authorization: `Bearer ${token}` } } : {})
      }
    ),
  getTicketAvailableCoverageIncorporations: (ticketId, token) =>
    client.get(
      `${apiTicket}${v2}/tickets/${ticketId}/available-coverage-incorporations`,
      {
        ...(token ? { headers: { Authorization: `Bearer ${token}` } } : {})
      }
    ),
  getTicketDependentIncorporations: (ticketId, token) =>
    client.get(
      `${apiTicket}${v2}/tickets/${ticketId}/dependent-incorporations`,
      {
        ...(token ? { headers: { Authorization: `Bearer ${token}` } } : {})
      }
    ),
  postTicketDependentIncorporation: (ticketId, payload, token) =>
    client.post(
      `${apiTicket}${v2}/tickets/${ticketId}/dependent-incorporations`,
      payload,
      {
        ...(token ? { headers: { Authorization: `Bearer ${token}` } } : {})
      }
    ),
  patchTicketDependentIncorporation: (
    ticketId,
    dependentIncorporationId,
    payload,
    token
  ) =>
    client.patch(
      `${apiTicket}${v2}/tickets/${ticketId}/dependent-incorporations/${dependentIncorporationId}`,
      payload,
      {
        ...(token ? { headers: { Authorization: `Bearer ${token}` } } : {})
      }
    ),
  deleteTicketDependentIncorporation: (
    ticketId,
    dependentIncorporationId,
    token
  ) =>
    client.delete(
      `${apiTicket}${v2}/tickets/${ticketId}/dependent-incorporations/${dependentIncorporationId}`,
      {
        ...(token ? { headers: { Authorization: `Bearer ${token}` } } : {})
      }
    ),
  getTicketDependentIncorporationCoverages: (
    ticketId,
    dependentIncorporationId,
    token
  ) =>
    client.get(
      `${apiTicket}${v2}/tickets/${ticketId}/dependent-incorporations/${dependentIncorporationId}/coverages`,
      {
        ...(token ? { headers: { Authorization: `Bearer ${token}` } } : {})
      }
    ),
  putTicketDependentIncorporationCoverages: (
    ticketId,
    dependentIncorporationId,
    payload,
    token
  ) =>
    client.put(
      `${apiTicket}${v2}/tickets/${ticketId}/dependent-incorporations/${dependentIncorporationId}/coverages`,
      payload,
      {
        ...(token ? { headers: { Authorization: `Bearer ${token}` } } : {})
      }
    ),
  patchTicketStatus: (ticketId, payload, token) =>
    client.patch(`${apiTicket}${v2}/tickets/${ticketId}/status`, payload, {
      ...(token ? { headers: { Authorization: `Bearer ${token}` } } : {})
    }),
  getCaseData: (id, token) =>
    client.get(`${apiTicket}${v1}/case/${id}`, {
      ...(token ? { headers: { Authorization: `Bearer ${token}` } } : {})
    }),
  getDependentsExclusionsOfTicket: (id) =>
    client.get(`${apiTicket}${v1}/ticket/${id}/dependents-exclusions`),
  // * Crear casos
  // Crear caso de rechazo
  caseRejection: (payload) =>
    client.post(`${apiTicket}${v1}/case/rechazo`, payload),
  getAppealEmails: (id, type) =>
    client.get(`${apiTicket}${v1}/insuranceCompany/${id}/mailbox?type=${type}`),
  postRejectionAppeal: (id, payload) =>
    client.post(`${apiTicket}${v1}/case/rechazo/${id}/apelacion`, payload),
  aprroveOrDenyAppeal: (id, action, payload) =>
    client.post(
      `${apiTicket}${v1}/case/rechazo/${id}/finish/${action}`,
      payload
    ),
  getCaseFiles: (id) => client.get(`${apiTicket}${v1}/case/${id}/files`),
  // * FETCH CASES
  getOutOfTimeCases: () =>
    client.get(`${apiTicket}${v1}/case?type=Out of Time`),
  getRejectionCases: () => client.get(`${apiTicket}${v1}/case?type=Rechazo`),
  getBackgroundCases: () =>
    client.get(`${apiTicket}${v1}/case?type=Antecedentes`),
  getMassiveExclusionTickets: () =>
    client.get(`${apiTicket}${v1}/ticket-groups?type=Baja`),
  getMassiveModificationTickets: () =>
    client.get(`${apiTicket}${v1}/ticket-groups?type=Modificacion`),
  getOptionalFilesDependentsTicketGroup: (payload) =>
    client.get(`${apiTicket}${v2}/ticket-groups/${payload}/optional-files`),
  getMassiveDependentsExclusionFormat: (companyId, insuranceCompanyId) => {
    return `${appConfig.baseURL}${apiTicket}${v1}/ticket-groups/massive-dependents-exclusion/download-format?company=${companyId}&insurance=${insuranceCompanyId}`;
  },
  createMassiveDependentsExclusion: (payload) => {
    return client.post(
      `${appConfig.baseURL}${apiTicket}${v1}/ticket-groups/massive-dependents-exclusion`,
      payload
    );
  },
  cancelMassiveDependentsExclusion: (ticketGroupId, payload) => {
    return client.post(
      `${appConfig.baseURL}${apiTicket}${v1}/ticket-groups/massive-dependents-exclusion/${ticketGroupId}/cancel`,
      payload
    );
  },
  presuccessMassiveDependantsExclusion: (ticketGroupId) => {
    return client.post(
      `${appConfig.baseURL}${apiTicket}${v1}/ticket-groups/massive-dependents-exclusion/${ticketGroupId}/pre-success`
    );
  },

  successMassiveDependantsExclusion: (ticketGroupId, payload) => {
    return client.post(
      `${appConfig.baseURL}${apiTicket}${v1}/ticket-groups/massive-dependents-exclusion/${ticketGroupId}/success`,
      payload
    );
  },
  precancelMassiveDependantsExclusion: (payload) => {
    return client.post(
      `${appConfig.baseURL}${apiTicket}${v1}/ticket-groups/massive-dependents-exclusion/${payload}/pre-cancel`
    );
  },
  cancelMassiveDependantsExclusion: (ticketGroupId, payload) => {
    return client.post(
      `${appConfig.baseURL}${apiTicket}${v1}/ticket-groups/massive-dependents-exclusion/${ticketGroupId}/cancel`,
      payload
    );
  },
  finishMassiveDependentsExclusion: (ticketGroupId, payload) => {
    return client.post(
      `${appConfig.baseURL}${apiTicket}${v1}/ticket-groups/massive-dependents-exclusion/${ticketGroupId}/finish`,
      payload
    );
  },
  getMassiveDependentsExclusionDetail: (ticketGroupId) => {
    return client.get(
      // `${appConfig.baseURL}${apiTicket}${v1}/ticket-groups/massive-dependents-exclusion/${ticketGroupId}`
      `${appConfig.baseURL}${apiTicket}${v1}/ticket-groups/${ticketGroupId}`
    );
  },
  getMassiveDependentsExclusionsOfTicket: (ticketGroupId) => {
    return client.get(
      `${appConfig.baseURL}${apiTicket}${v1}/ticket-groups/massive-dependents-exclusion/${ticketGroupId}`
    );
  },
  getMassiveDependentsExclusionFiles: (ticketGroupId) => {
    return client.get(
      `${appConfig.baseURL}${apiTicket}${v1}/ticket-groups/massive-dependents-exclusion/${ticketGroupId}/files`
    );
  },
  getUploadStockTemplate: (companyId, insuranceCompanyId) => {
    return `${appConfig.baseURL}${apiTicket}${v2}/stock-incorporations/template?companyId=${companyId}&insuranceCompanyId=${insuranceCompanyId}`;
  },
  createStockIncorporation: (payload) =>
    client.post(`${apiTicket}${v2}/stock-incorporations`, payload),
  getStockFiles: (companyId, page, size) => {
    return client.get(
      `${appConfig.baseURL}${apiTicket}${v2}/stock-incorporations`,
      {
        params: { companyId, page, size }
      }
    );
  },
  getStockFile: (fileId) => {
    return `${appConfig.baseURL}${apiTicket}${v2}/stock-incorporations/${fileId}/file`;
  },
  getProcessedFile: (fileId) => {
    return `${appConfig.baseURL}${apiTicket}${v2}/stock-incorporations/${fileId}/result`;
  },
  getMovementFiles: (companyId, page, size) => {
    return client.get(
      `${appConfig.baseURL}${apiTicket}${v1}/ticket-groups/movement-files`,
      {
        params: { companyId, page, size }
      }
    );
  },
  getMovementFile: (fileId) => {
    return `${appConfig.baseURL}${apiTicket}${v1}/ticket-groups/${fileId}/download-movement-file`;
  },
  getMovementProcessedFile: (fileId) => {
    return `${appConfig.baseURL}${apiTicket}${v1}/ticket-groups/${fileId}/download-movement-processed-file`;
  },
  // NOTE: returns employee/policy-holder coverages (no allowDependents filter).
  // Distinct from getTicketAvailableCoverages which calls the v2 dependants endpoint.
  coveragePolicy: (payload) =>
    client.get(
      `${appConfig.baseURL}${apiTicket}${v1}/ticket/${payload}/employee-coverages-available`
    ),
  coverageIncorporations: (payload) =>
    client.get(
      `${appConfig.baseURL}${apiTicket}${v1}/ticket/${payload}/coverage-incorporations`
    ),
  createAltaIndividual: (payload) =>
    client.post(
      `${appConfig.baseURL}${apiTicket}${v1}/policy/form-alta?company=${payload.company}&insurance=${payload.insurance}&rut=${payload.rut}`
    ),
  fileRequest: (payload) =>
    client.get(`https://bewell-s3.s3.us-west-2.amazonaws.com/${payload}`, {
      withCredentials: false
    }),

  getDependentsIncorporationForm: (token) =>
    client.get(`${apiTicket}${v1}/dependents-incorporation-form`, {
      headers: { Authorization: `Bearer ${token}` }
    }),

  getDependentsIncorporationFormEmployee: (token) =>
    client.get(`${apiTicket}${v1}/dependents-incorporation-form/employee`, {
      headers: { Authorization: `Bearer ${token}` }
    }),

  putDocumentOfDependentsIncorporationForm: ({ token, payload }) =>
    client.put(
      `${apiTicket}${v1}/dependents-incorporation-form/documents`,
      payload,
      { headers: { Authorization: `Bearer ${token}` } }
    ),
  resendDependentsIncorporationForm: (token) =>
    client.post(
      `${apiTicket}${v1}/dependents-incorporation-form/reset-token`,
      {},
      { headers: { Authorization: `Bearer ${token}` } }
    ),
  resendDependentsIncorporationNoDeliverableForm: (token) =>
    client.post(
      `${apiTicket}${v1}/dependents-incorporation-form/reset-no-deliverable-token`,
      {},
      { headers: { Authorization: `Bearer ${token}` } }
    ),
  sendToBrokerDependentsIncorporationForm: (token) =>
    client.post(
      `${apiTicket}${v1}/dependents-incorporation-form/send-to-broker`,
      {},
      { headers: { Authorization: `Bearer ${token}` } }
    ),
  getPoliciesForDependentsIncorporation: ({
    rut,
    companyId,
    insuranceCompanyId
  }) =>
    client.get(`${apiTicket}${v1}/dependents-incorporation-form/policies`, {
      params: { rut, companyId, insuranceCompanyId }
    }),
  getCompaniesForDependentsIncorporation: (rut) =>
    client.get(`${apiTicket}${v1}/dependents-incorporation-form/companies`, {
      params: { rut }
    }),
  updateEndDateBeforeFinishExclusion: (id, endDate) =>
    client.post(
      `${apiTicket}${v1}/ticket/${id}/update-end-date-before-finish-exclusion`,
      { endDate }
    ),
  getMovementFilesByTicketGroup: (ticketGroupId) =>
    client.get(
      `${apiTicket}${v1}/ticket-groups/${ticketGroupId}/movement-files`
    ),

  getMovementFileByTicketGroup: (ticketGroupId) =>
    client.get(
      `${apiTicket}${v1}/ticket-groups/${ticketGroupId}/movement-file`
    ),

  getProcessedFileByTicketGroup: (ticketGroupId) =>
    client.get(
      `${apiTicket}${v1}/ticket-groups/${ticketGroupId}/processed-file`
    ),

  getProcessedFilesByTicketGroupIds: (ticketGroupIds) => {
    const query = ticketGroupIds.map((id) => `ids=${id}`).join('&');
    return client.get(
      `${apiTicket}${v1}/ticket-groups/processed-files?${query}`
    );
  }
});
export default network;
